import { useQuery, useQueryClient } from '@tanstack/react-query';

import { SIMILAR_TO_SOLD_FETCH_PRODUCTS_COUNT } from '../constants';
import { similarToSoldQueryOptions } from '../queries';

import { RQ_X_COUNTRY_CODE } from '@/modules/ReactQuery/cacheKeys';
import { useCurrentLanguage } from '@/modules/language/useCurrentLanguage';
import { useCurrentLocation } from '@/modules/location/useCurrentLocation';
import { useCurrentUser } from '@/modules/user/useCurrentUser';

export function useSimilarToSoldProducts(soldProductIds: number[]) {
  const { language } = useCurrentLanguage();
  const { location } = useCurrentLocation();
  const [, user] = useCurrentUser();
  const queryClient = useQueryClient();
  const buyerCountry = user
    ? user.country
    : queryClient.getQueryData<string>([RQ_X_COUNTRY_CODE]);

  return useQuery(
    similarToSoldQueryOptions({
      soldProductIds: soldProductIds.slice(
        0,
        SIMILAR_TO_SOLD_FETCH_PRODUCTS_COUNT
      ),
      params: {
        country: location,
        lang: language,
        hide_sold_products: true,
      },
      withAuth: true,
      buyerCountry,
    })
  );
}
